export { default } from './TasteProfileIcon'
export { icons } from './TasteProfileIcon'
export { iconNames } from './TasteProfileIcon'
